module.exports = __webpack_public_path__ + "static/media/female-office-worker_1f469-200d-1f4bc.b2aedd07.png";